export enum StructureTypeEnum {
  Headquarters = 'headquarters',
  Campus = 'campus',
  SchoolLevel = 'school_level',
  Grade = 'grade',
  SubjectGroup = 'subject_group',
}
